import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    dragCell: {
        position: "relative",
    },
    dragging: {
        opacity: 0.4,
    },
    dragHandle: {
        marginLeft: theme.spacing(1),
    },
    collapseBtn: {
        "&:focus": {
            outline: "none",
        },
    },
    icon: {
        borderRadius: theme.spacing(1),
        boxSizing: "border-box",
        padding: theme.spacing(2),
    },
    iconDisabled: {
        color: theme.palette.emteria.border.primary,
        border: "1px solid " + theme.palette.emteria.border.primary,
    },
    icons: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(2),
        color: theme.palette.emteria.border.primary,
    },
    collapsingRowContent: {
        padding: theme.spacing(2),
        width: "100%",
        maxWidth: "100%",
        minHeight: 36,
        textAlign: "left",
        wordWrap: "break-word",
    },
    buttonBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
        height: 50,
    },
    customCollapse: {
        "& .MuiCollapse-wrapper": {
            maxWidth: "650px",
        },
    },
}));
